import { PlanogramRenderer } from "./assets/PlanogramRenderer";
import { PlanogramContainer } from "./assets/PlanogramContainer";
import { PlanogramCamera } from "./assets/PlanogramCamera";
import { PlanogramCameraFrame } from "./assets/PlanogramCameraFrame";
import { PlanogramSubcomponent } from "./assets/PlanogramSubcomponent";
import { PlanogramComponent } from "./assets/PlanogramComponent";
import { PlanogramDivider } from "./assets/PlanogramDivider";
import { PlanogramPosition } from "./assets/PlanogramPosition";
import { PlanogramPositionCap } from "./assets/PlanogramPositionCap";
import { PlanogramPeg } from "./assets/PlanogramPeg";
import { PlanogramImage } from "./assets/PlanogramImage";
import { PlanogramText } from "./assets/PlanogramText";
import { PlanogramBlocking } from "./assets/PlanogramBlocking";
import { PlanogramBlockingPosition } from "./assets/PlanogramBlockingPosition";
import { PlanogramBlockingDivider } from "./assets/PlanogramBlockingDivider";
import { PlanogramToolBar } from "./assets/PlanogramToolBar";
import { PlanogramLabel } from "./assets/PlanogramLabelController";

customElements.define("planogram-toolbar", PlanogramToolBar);
customElements.define("planogram-renderer", PlanogramRenderer);
customElements.define("planogram-container", PlanogramContainer);
customElements.define("planogram-camera", PlanogramCamera);
customElements.define("planogram-camera-frame", PlanogramCameraFrame);
customElements.define("planogram-component", PlanogramComponent);
customElements.define("planogram-subcomponent", PlanogramSubcomponent);
customElements.define("planogram-divider", PlanogramDivider);
customElements.define("planogram-position", PlanogramPosition);
customElements.define("planogram-position-cap", PlanogramPositionCap);
customElements.define("planogram-peg", PlanogramPeg);
customElements.define("planogram-image", PlanogramImage);
customElements.define("planogram-text", PlanogramText);
customElements.define("planogram-blocking", PlanogramBlocking);
customElements.define("planogram-blocking-location", PlanogramBlockingPosition);
customElements.define("planogram-blocking-divider", PlanogramBlockingDivider);
customElements.define("planogram-label", PlanogramLabel);